// GSAP tween 的 Promise 包裝 — 取代 Unity DOTween 的 UniTask 等待寫法。

import gsap from 'gsap'

/** 正常播完或被 killTweensOf() 中斷都會 resolve（視為「這個補間的責任已結束」），避免呼叫端的 Promise.all 永遠卡住等不到值。 */
export function tweenTo(target: object, vars: gsap.TweenVars): Promise<void> {
  return new Promise((resolve) => {
    gsap.to(target, { ...vars, onComplete: () => resolve(), onInterrupt: () => resolve() })
  })
}

export function killTweensOf(targets: object | object[]): void {
  gsap.killTweensOf(targets)
}
